module.exports = __webpack_public_path__ + "assets/img/teacher (23).d6fbcbb5.png";